// The FAQ list, as native <details>/<summary>.
//
// Deliberately not a React state accordion. Three reasons, all load bearing:
//   1. It works with JavaScript off, so the prerendered HTML a crawler reads is
//      the same content a visitor gets.
//   2. The FAQPage JSON-LD must match the rendered DOM. With <details> the answer
//      text is always IN the markup, open or shut. A state accordion that only
//      mounts the open answer serves Google markup for text that’s not on the
//      page, which is a structured data violation.
//   3. Keyboard and screen reader behaviour comes free and correct.
//
// Pass the SAME array to faqJsonLd() in src/lib/jsonLd.js so the two can never
// disagree.

export default function FaqAccordion({ items, className = '' }) {
  if (!items?.length) return null
  return (
    <div className={`divide-y divide-hairline border-y border-hairline ${className}`}>
      {items.map(({ q, a }) => (
        <details key={q} className="group py-5">
          <summary className="flex cursor-pointer list-none items-start justify-between gap-6 text-[19px] font-semibold text-ink [&::-webkit-details-marker]:hidden">
            {q}
            <span
              aria-hidden="true"
              className="mt-1 shrink-0 text-ink-muted transition-transform duration-200 group-open:rotate-45"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M12 5v14M5 12h14" />
              </svg>
            </span>
          </summary>
          <div className="pt-3 pr-10 text-[17px] leading-relaxed text-ink-muted">{a}</div>
        </details>
      ))}
    </div>
  )
}
